module.exports = __webpack_public_path__ + "img/w3.3f3ffd9e.png";